import React from 'react'
import styled from 'styled-components'
import Brand from 'helpers/brand'

import { color } from 'styles/colors'
import { removeScriptTags } from 'helpers/formatters'

import { SiteMessageDetail } from 'types/SiteMessageDetail'

type Props={
  title: string
  message: string
  siteMessages: Array<SiteMessageDetail>
}

const FeatureTourIntroCard = ({ title, message, siteMessages }: Props) => {
  return (
    <S.Container>
      <S.BrandLogo src={Brand.productLogoPath()} aria-label="brand-logo" alt={`${Brand.productLogoPath()} logo`} />
      <br />
      <div>
        <S.Heading>{title}</S.Heading>
        <ul>
          {
            siteMessages.map((siteMessage) => (
              <S.List key={siteMessage.id}>{siteMessage.title}</S.List>
            ))
          }
        </ul>
        <br />
        <S.Message
          dangerouslySetInnerHTML={{
            __html: removeScriptTags(message)
          }}
        />
      </div>
    </S.Container>
  )
}

export default FeatureTourIntroCard

const S = {
  Container: styled.div`
    padding: 20px;
    text-align: left;
  `,
  Heading: styled.h2`
    color: ${color('featureToursHeading')};
    margin-top: 25px;
  `,
  BrandLogo: styled.img`
    display: block;
    width: 50% !important;
    margin: auto;
  `,
  List: styled.li`
    color: ${color('primaryText')};
    font-size: 16px;
  `,
  HelpText: styled.p`
    color: ${color('primaryText')}
  `,
  Message: styled.p`
    color: ${color('primaryText')};
    font-size: 16px;
    line-height: 1.5;
  `

}
